import { v4 as uuid } from 'uuid';

/*
 * app initialization happened before kickstart is executed..
 */
async function initApp (navigate) {
    window.navigate = navigate;
    this.navigate = navigate;

    const params = this.appStore.initParams();

    /*
    const location = window.location;
    const urlSearchParams = new URLSearchParams(location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    
    this.page = {
        path: location.pathname,
        params: params,
        sessionSettings: this.getSessionSettings(),
        location,
        completePath: `${location.href}`,
    };
 
    window.history.replaceState({ url:  this.page.completePath }, '', this.page.completePath);
    if (params.mode === 'preview') {
        this.appStore.isPreview = true;
    }
    */ 

    if (this.page.path.indexOf('/oauthTalking') !== -1) {
        console.log('oauthTalking...');
        this.oauthSession = {
            ...params,
        };
        this.setSessionSettings(this.oauthSession);
        this.appStore.observed.oauthSession = uuid();
    }

}

export default initApp;
